// English translations
export default {
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    search: 'Search',
    filter: 'Filter',
    all: 'All',
    yes: 'Yes',
    no: 'No',
    confirm: 'Confirm',
    logout: 'Log Out',
    login: 'Log In',
    expand: 'Expand',
    collapse: 'Collapse'
  },
  header: {
    home: 'Home',
    maps: 'Maps',
    products: 'Products',
    services: 'Services',
    about: 'About Spectra',
    login: 'Log In'
  },
  home: {
    title: 'SPECTRA',
    subtitle: 'Satellite Platform for Emergency Crisis, Tracking and Remote Analytic',
    description: 'Satellite-based platform for disaster management and geospatial analysis',
    heroHeading: 'Near-Realtime. Open. Unlimited Insights',
    heroDescription: 'SPECTRA is a Satellite Platform for Emergency Crisis Tracking and Remote Analytics. Access high-quality satellite imagery, updated periodically and near-realtime for disaster monitoring, research, rapid response, and data-driven decision making.',
    searchTitle: 'Start exploring image data',
    searchRegion: 'Region Name',
    searchRegionPlaceholder: 'Enter region name',
    searchEventType: 'Event Type',
    searchButton: 'Search Data',
    latestReleases: 'Latest Releases',
    previous: 'Previous',
    next: 'Next',
    viewAll: 'View All',
    interactiveMap: 'Interactive Map',
    interactiveMapDesc: 'Access interactive maps for geospatial data visualization and disaster analysis',
    accessMap: 'Access Map',
    partners: 'Collaboration Partners',
    allEvents: 'All events',
    banjir: 'Flood',
    longsor: 'Landslide',
    access: 'Access',
    loadingLatest: 'Loading latest products...',
    clickToClose: 'Click outside image to close',
    pressEscape: 'Press ESC to close'
  },
  maps: {
    title: 'Dynamic Maps',
    subtitle: 'Explore interactive maps with various layers and basemaps',
    selectMap: 'Select Map',
    loading: 'Loading map...',
    error: 'Error loading map',
    noData: 'Map not found',
    layers: 'Map Layers',
    showAll: 'Show All',
    hideAll: 'Hide All',
    basemap: 'Basemap',
    zoomToLayer: 'Zoom to Layer',
    opacity: 'Opacity',
    selectBasemap: 'Select Basemap',
    viewMap: 'View Map',
    zoom: 'Zoom',
    center: 'Center Point',
    noMapsAvailable: 'No maps available',
    showInfo: 'Show Map Info',
    legend: 'Legend'
  },
  products: {
    title: 'Spectra Products',
    breadcrumbHome: 'Home',
    breadcrumbProducts: 'Products',
    searchPlaceholder: 'Enter region name',
    searchRegion: 'Region Name',
    searchEventType: 'Event Type',
    allEvents: 'All events',
    allCategories: 'All Categories',
    noResults: 'No products found',
    loading: 'Loading products...',
    access: 'Access',
    preview: 'Preview',
    download: 'Download',
    date: 'Date',
    region: 'Region',
    category: 'Category',
    clickToClose: 'Click outside image to close',
    pressEscape: 'Press ESC to close',
    latest: 'Latest',
    oldest: 'Oldest',
    releaseDate: 'Release Date'
  },
  mapAdmin: {
    title: 'Map Admin',
    createMap: 'Create New Map',
    editMap: 'Edit Map',
    deleteMap: 'Delete Map',
    createGroup: 'Create New Layer Group',
    editGroup: 'Edit Layer Group',
    deleteGroup: 'Delete Layer Group',
    createLayer: 'Create New Layer',
    editLayer: 'Edit Layer',
    deleteLayer: 'Delete Layer',
    viewMap: 'View Map',
    name: 'Name',
    description: 'Description',
    center: 'Center Point',
    zoom: 'Zoom Level',
    public: 'Public',
    layerName: 'Layer Name',
    layerType: 'Layer Type',
    url: 'URL',
    zIndex: 'Z-Index',
    visible: 'Visible',
    style: 'Style (JSON)',
    geometry: 'Geometry (GeoJSON)',
    save: 'Save',
    cancel: 'Cancel',
    success: 'Success',
    error: 'Error',
    noMaps: 'No maps',
    noGroups: 'No layer groups',
    noLayers: 'No layers',
    mapCreated: 'Map created successfully',
    mapUpdated: 'Map updated successfully',
    mapDeleted: 'Map deleted successfully',
    groupCreated: 'Layer group created successfully',
    groupUpdated: 'Layer group updated successfully',
    groupDeleted: 'Layer group deleted successfully',
    layerCreated: 'Layer created successfully',
    layerUpdated: 'Layer updated successfully',
    layerDeleted: 'Layer deleted successfully',
    failedToLoad: 'Failed to load map details',
    failedToCreate: 'Failed to create map',
    failedToUpdate: 'Failed to update map',
    failedToDelete: 'Failed to delete map',
    layers: 'Layers',
    layerGroups: 'Layer Groups'
  },
  profile: {
    title: 'About SPECTRA',
    subtitle: 'Satellite Platform for Disaster Management'
  },
  contact: {
    title: 'Contact Us',
    contactInfo: 'Contact Information',
    availableServices: 'Available Services',
    operatingHours: 'Operating Hours',
    technicalSupport: 'Technical Support',
    training: 'Training & Capacity Building',
    dataAccess: 'Data Access',
    collaboration: 'Collaboration',
    mondayFriday: 'Monday - Friday',
    saturdaySunday: 'Closed',
    urgentNote: 'For urgent requests, please contact via email with subject "URGENT"'
  },
  services: {
    title: 'Web Services',
    subtitle: 'Documentation for using WMS, WCS, and WFS services to access SPECTRA BRIN geospatial data.',
    wms: 'WMS',
    wcs: 'WCS',
    wfs: 'WFS',
    getCapabilities: 'GetCapabilities',
    getMap: 'GetMap',
    getFeatureInfo: 'GetFeatureInfo',
    describeCoverage: 'DescribeCoverage',
    getCoverage: 'GetCoverage',
    describeFeatureType: 'DescribeFeatureType',
    getFeature: 'GetFeature',
    transaction: 'Transaction',
    helpTitle: 'Need Help?',
    helpText: 'For questions or technical support related to web services usage, please contact the SPECTRA BRIN team through the'
  },
  disclaimer: {
    title: 'Disclaimer & Terms of Data Use',
    warning: 'MUST READ: Terms of use for geospatial data and SPECTRA BRIN map products',
    lastUpdated: 'Last updated',
    version: 'Version'
  },
  footer: {
    copyright: `© ${new Date().getFullYear()} SPECTRA BRIN. All rights reserved.`
  },
  mapProducts: {
    title: 'Interactive Map Products',
    subtitle: 'Space-based data visualization for disaster management and emergency response.',
    modeLabel: 'Map view mode',
    modeProducts: 'Product Map',
    modeProductsDesc: 'Ready-made layers for monitoring',
    modeCatalog: 'Imagery Catalog',
    modeCatalogDesc: 'Search and view STAC satellite imagery'
  },
  stacCatalog: {
    panelTitle: 'Imagery Catalog',
    panelHint: 'Showing imagery within the visible map area',
    connectionError: 'Could not connect to STAC server. Check network or restart npm start.',
    waitingExtent: 'Waiting for map area...',
    noResultsInExtent: 'No imagery in this map area. Pan or zoom the map and try again.',
    guideStep2: 'Pick an image from the list',
    guideStep3: 'View it on the map',
    dismissGuide: 'Dismiss guide',
    filters: 'Filters',
    filtersHint: 'Optional — leave empty to browse all data',
    closeFilters: 'Close filters',
    openFilters: 'Filters',
    collections: 'Satellite collections',
    collectionsHint: 'Selecting none means all collections',
    selectAll: 'All',
    clearSelection: 'Clear',
    dateRange: 'Date range',
    dateHint: 'Leave blank to include all dates',
    invalidDateRange: 'Start date must be before end date.',
    from: 'From',
    to: 'To',
    search: 'Search imagery',
    searching: 'Searching...',
    reset: 'Reset',
    results: 'Results',
    resultsHint: 'Pan or zoom the map to refresh the imagery list',
    showResults: 'Results',
    hideResults: 'Hide results',
    noResults: 'No imagery matched. Try adjusting filters.',
    adjustFilters: 'Adjust filters',
    noPreview: 'No preview',
    previewThumb: 'Enlarge preview',
    noDate: 'No date',
    popupCollection: 'Collection',
    popupDate: 'Date',
    showOnMap: 'Show on map',
    showingOnMap: 'Showing on map',
    viewing: 'Viewing',
    clearView: 'Clear',
    pickHint: 'Pick an image from the list or click an area on the map',
    emptyMapHint: 'No results yet — use filters then search',
    hideExtents: 'Hide extents',
    showExtents: 'Show extents',
    footprintOn: 'Footprint on',
    footprintOff: 'Footprint off',
    showFootprint: 'Show footprint on map',
    hideFootprint: 'Hide footprint on map',
    loadingTiles: 'Loading imagery...',
    showGis: 'Copy URL for GIS',
    hideGis: 'Hide GIS URL',
    gisHint: 'For QGIS/ArcGIS — not needed to view here',
    copyXyz: 'Copy',
    copied: 'Copied',
    basemap: {
      mapbox: 'Light map',
      googleHybrid: 'Satellite',
      osm: 'OSM'
    }
  }
};

